import { render, staticRenderFns } from "./TagDeleteModal.vue?vue&type=template&id=53efa181"
import script from "./TagDeleteModal.vue?vue&type=script&lang=js"
export * from "./TagDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports